import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-childhood-snowman.jpg`;
const ALT = "A young Lara in a red snowsuit, crouched in front of a snowman roughly the size of a garage, surrounded by family.";

export function ChildhoodWonder() {
  return (
    <section data-testid="about-childhood-wonder" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band, left side */}
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[48%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="childhood-wonder-image"
            bg="#FAFAF8"
            objectPosition="46% 42%"
            featherRight={44}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="childhood-wonder-image-mobile"
            bg="#FAFAF8"
            objectPosition="46% 38%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean right */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center justify-end lg:min-h-[min(64vh,540px)]">
          <div className="w-full lg:w-[52%]">
            <div className="max-w-[500px] lg:ml-auto">
              <p
                data-testid="childhood-wonder-header"
                className="font-display text-[26px] md:text-[34px] text-[#1C1917] leading-[1.25] mb-5"
              >
                I come by it honestly.
              </p>
              <div
                data-testid="childhood-wonder-body"
                className="space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E]"
              >
                <p>
                  In our family, dreaming big was just part of growing up.
                </p>
                <p>
                  One winter, someone decided we should build a snowman
                  roughly the size of a garage.
                </p>
                <p>So we did.</p>
                <p>
                  Looking back, I don&rsquo;t think any of us spent much time
                  worrying about whether something was possible.
                </p>
                <p>We were usually too busy figuring out how.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
